import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import RelaxInMurrieta from "./sections/RelaxInMurrieta";
import WhyWorkGenLeadsInEssex from "./sections/WhyWorkGenLeadsInEssex";
import StayAwhile from "./sections/StayAwhile";
import MinutesFromTheMagic from "./sections/MinutesFromTheMagic";
import StartYourStory from "./sections/StartYourStory";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <RelaxInMurrieta />
      <WhyWorkGenLeadsInEssex />
      <StayAwhile />
      <MinutesFromTheMagic />
      <StartYourStory />
      <Footer />
    </div>;
}